// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as Belt_Array from "@rescript/runtime/lib/es6/Belt_Array.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogProduct from "../../modules/Catalog/CatalogProduct.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantNotesCard from "../../modules/Catalog/CatalogVariantNotesCard.res.js";
import * as CatalogVariantPageActions from "../../modules/Catalog/CatalogVariantPageActions.res.js";
import * as CatalogVariantStockTableCard from "../../modules/Catalog/CatalogVariantStockTableCard.res.js";
import * as CatalogVariantInformationCard from "../../modules/Catalog/CatalogVariantInformationCard.res.js";
import * as CatalogVariantStatusTableCard from "../../modules/Catalog/CatalogVariantStatusTableCard.res.js";
import * as CatalogVariantOrderSupplyTableCard from "../../modules/Catalog/CatalogVariantOrderSupplyTableCard.res.js";
import * as CatalogVariantRetailPriceTableCard from "../../modules/Catalog/CatalogVariantRetailPriceTableCard.res.js";
import * as CatalogVariantProductInformationCard from "../../modules/Catalog/CatalogVariantProductInformationCard.res.js";
import * as CatalogVariantPurchasePriceTableCard from "../../modules/Catalog/CatalogVariantPurchasePriceTableCard.res.js";
import * as CatalogVariantStockActivityTableCard from "../../modules/Catalog/CatalogVariantStockActivityTableCard.res.js";
import * as CatalogVariantStockThresholdFormCard from "../../modules/Catalog/CatalogVariantStockThresholdFormCard.res.js";

function mapToVariantPrices(shopsVariantRetailPrices, shopsVariantPurchasePrice) {
  return Stdlib_Array.reduce(shopsVariantRetailPrices, [], (acc, arr) => Belt_Array.concatMany([
    acc,
    arr
  ])).map(retailPrice => ({
    id: retailPrice.id,
    priceId: retailPrice.priceId,
    variantId: retailPrice.variantId,
    shopName: retailPrice.shopName,
    name: retailPrice.name,
    valueExcludingTax: retailPrice.valueExcludingTax,
    valueIncludingTax: retailPrice.valueIncludingTax,
    taxRate: retailPrice.taxRate,
    taxIncluded: retailPrice.taxIncluded,
    purchasePrice: Stdlib_Option.getOr(Stdlib_Option.flatMap(shopsVariantPurchasePrice.find(current => current.shopId === retailPrice.shopId), param => param.purchasePrice), 0),
    toQuantity: retailPrice.toQuantity,
    fromQuantity: retailPrice.fromQuantity,
    capacityUnit: retailPrice.capacityUnit,
    edited: false
  }));
}

function CatalogVariantPage$AuthSelectShop(props) {
  let variantShopIds = props.variantShopIds;
  let shops = Auth.useShops();
  let disabledIds = Stdlib_Array.filterMap(shops, param => {
    let id = param.id;
    let match = variantShopIds.find(current => current === id);
    if (match !== undefined) {
      return;
    } else {
      return id;
    }
  });
  return JsxRuntime.jsx(Auth.SelectShopFilter.make, {
    disabledIds: disabledIds
  });
}

let AuthSelectShop = {
  make: CatalogVariantPage$AuthSelectShop
};

function CatalogVariantPage(props) {
  let shopsVariantRetailPrices = props.shopsVariantRetailPrices;
  let shopsVariantPurchasePrice = props.shopsVariantPurchasePrice;
  let shopsVariantStock = props.shopsVariantStock;
  let shopsVariant = props.shopsVariant;
  let variantShopIds = props.variantShopIds;
  let cku = props.cku;
  let fromLabelEditSettingsRedirected = props.fromLabelEditSettingsRedirected;
  let notifier = Notifier.use(undefined, undefined);
  let scope = Auth.useScope();
  let someVariant = shopsVariant.length !== 0;
  let onRequestNotification = value => {
    if (value.TAG === "Ok") {
      return notifier.reset({
        TAG: "Success",
        _0: value._0
      }, undefined, undefined);
    } else {
      return notifier.reset({
        TAG: "Error",
        _0: value._0
      }, undefined, undefined);
    }
  };
  let renderActions = () => {
    let match = shopsVariant[0];
    if (scope.TAG === "Organisation" || match === undefined) {
      return null;
    } else {
      return JsxRuntime.jsx(CatalogVariantPageActions.make, {
        cku: cku,
        variant: match,
        fromLabelEditSettingsRedirected: fromLabelEditSettingsRedirected,
        onRequestNotification: onRequestNotification
      });
    }
  };
  let renderHeaderActions;
  if (scope.TAG === "Organisation") {
    let shops = scope.shops;
    renderHeaderActions = () => {
      let variant = shopsVariant[0];
      return JsxRuntime.jsxs(Inline.make, {
        children: [
          JsxRuntime.jsxs(Inline.make, {
            children: [
              shops.length < 6 ? JsxRuntime.jsx(CatalogVariantPage$AuthSelectShop, {
                  variantShopIds: variantShopIds
                }) : null,
              someVariant ? null : JsxRuntime.jsx(TextStyle.make, {
                  children: I18n.t("No variant association to this shop has been recorded."),
                  variation: "negative"
                })
            ],
            space: "normal"
          }),
          variant !== undefined ? JsxRuntime.jsx(CatalogVariantPageActions.make, {
              cku: cku,
              variant: variant,
              fromLabelEditSettingsRedirected: fromLabelEditSettingsRedirected,
              onRequestNotification: onRequestNotification
            }) : null
        ],
        align: "spaceBetween",
        grow: true
      });
    };
  } else {
    renderHeaderActions = undefined;
  }
  let pageTitle = Stdlib_Option.map(shopsVariant[0], param => param.formattedName);
  let renderTitleEnd = () => {
    let match = shopsVariant[0];
    let variant;
    if (match === undefined) {
      return null;
    }
    if (scope.TAG === "Organisation") {
      if (scope.activeShop === undefined) {
        return null;
      }
      variant = match;
    } else {
      variant = match;
    }
    let status = variant.status;
    return JsxRuntime.jsx("div", {
      children: status !== undefined ? JsxRuntime.jsx(CatalogProduct.Status.Badge.make, {
          value: status
        }) : null,
      style: {
        alignSelf: "center"
      }
    });
  };
  let tmp;
  if (someVariant) {
    let tmp$1;
    tmp$1 = scope.TAG === "Organisation" && scope.activeShop === undefined ? JsxRuntime.jsx(CatalogVariantStatusTableCard.make, {
        shopsVariant: shopsVariant
      }) : null;
    let match = shopsVariantStock[0];
    let match$1 = shopsVariant[0];
    let tmp$2;
    if (match !== undefined) {
      let exit = 0;
      if (scope.TAG === "Organisation" && scope.activeShop === undefined) {
        tmp$2 = null;
      } else {
        exit = 1;
      }
      if (exit === 1) {
        tmp$2 = match$1 !== undefined && !match$1.bulk ? JsxRuntime.jsx(CatalogVariantStockThresholdFormCard.make, {
            variantId: match.variantId,
            maxStockThreshold: match.maxStockThreshold,
            minStockThreshold: match.minStockThreshold,
            stockOrderTriggerThreshold: match.stockOrderTriggerThreshold
          }) : null;
      }
    } else {
      tmp$2 = null;
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx(Notifier.Banner.make, {
          notifier: notifier
        }),
        JsxRuntime.jsx(Box.make, {
          children: JsxRuntime.jsx(Stack.make, {
            children: JsxRuntime.jsxs(Group.make, {
              children: [
                JsxRuntime.jsxs(Stack.make, {
                  children: [
                    JsxRuntime.jsx(CatalogVariantInformationCard.make, {
                      shopsVariant: shopsVariant
                    }),
                    JsxRuntime.jsx(CatalogVariantStockTableCard.make, {
                      cku: cku,
                      shopsVariantStock: shopsVariantStock
                    }),
                    JsxRuntime.jsx(CatalogVariantProductInformationCard.make, {
                      cku: cku,
                      shopsProduct: props.shopsProduct
                    }),
                    tmp$1,
                    JsxRuntime.jsx(CatalogVariantNotesCard.make, {
                      shopsNotes: shopsVariant.map(variant => ({
                        variantId: variant.id,
                        shopId: variant.shopId,
                        internalNote: variant.internalNote,
                        tastingNote: variant.tastingNote
                      }))
                    })
                  ],
                  space: "medium"
                }),
                JsxRuntime.jsxs(Stack.make, {
                  children: [
                    JsxRuntime.jsx(CatalogVariantRetailPriceTableCard.make, {
                      cku: cku,
                      variantPrices: mapToVariantPrices(shopsVariantRetailPrices, shopsVariantPurchasePrice)
                    }),
                    JsxRuntime.jsx(CatalogVariantPurchasePriceTableCard.make, {
                      shopsVariantPrices: shopsVariantPurchasePrice.map((purchasePriceData, index) => ({
                        purchasePriceData: purchasePriceData,
                        retailPricesData: shopsVariantRetailPrices[index]
                      }))
                    }),
                    JsxRuntime.jsx(CatalogVariantStockActivityTableCard.make, {
                      cku: cku
                    }),
                    JsxRuntime.jsx(CatalogVariantOrderSupplyTableCard.make, {
                      cku: cku
                    }),
                    tmp$2
                  ],
                  space: "medium"
                })
              ],
              grid: [
                "30%",
                "70%"
              ],
              wrap: false,
              spaceX: "medium"
            }),
            space: "medium"
          }),
          spaceTop: "medium"
        })
      ]
    });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(Page.make, {
    children: tmp,
    title: pageTitle,
    renderTitleEnd: renderTitleEnd,
    renderActions: renderActions,
    renderHeaderActions: renderHeaderActions
  });
}

let make = React.memo(CatalogVariantPage);

let Config;

export {
  Config,
  mapToVariantPrices,
  AuthSelectShop,
  make,
}
/* make Not a pure module */
